import { type SubscriptionDocuments } from './useOracleChatSubscription'

/**
 * Returns true if any document in the streaming payload contains
 * divination card data (oracle, tarot, or future horoscope).
 */
export const hasStreamingDivinationDocuments = (
  docs: SubscriptionDocuments | null | undefined,
): boolean => docs?.some(
  (doc) => doc.oracle || doc.tarot,
  // When horoscope is added to the schema, include: || doc.horoscope
) ?? false
